import * as yup from 'yup';
export const TagSchema = yup.object({
  id: yup.string().label('id').required(),
  type: yup.string().label('type').required(),
});
